export default {
  getNotificationReceipt: (state) => state.notificationReceipt,
};
